export default "__VITE_ASSET__CfLtNEpP__"